import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    paymentForms() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get("/koraniklandigital/paymentForm");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'istayang', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklandigitalmuat${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listgeser(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'istayang', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklandigitalmuat/geser${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    bookingspace(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'istayang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklandigitalmuat/bookingspace${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/koraniklandigitalmuat', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    geser(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/koraniklandigitalmuat/${data.orderlineid}`, data);
                resolve(resp);
            } catch (error) {
                // console.log(error);
                errorHandler(error, reject);
            }
        });
    },
    exportbookspace(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/koraniklandigitalmuat/exportbookspace${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'bookingspace-cetak.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportiklanbaris(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/koraniklandigitalmuat/exportiklanbaris${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'iklanbaris.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    exportgeser(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'istayang', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/koraniklandigitalmuat/exportgeser${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'geserjadwaliklandigital.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'istayang', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/koraniklandigitalmuat/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'realisasi-iklan-cetak.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printbookspace(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/koraniklandigitalmuat/printbookspace/${str}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    printiklanbaris(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/koraniklandigitalmuat/printiklanbaris/${str}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },     
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/koraniklandigitalmuat/${obj.orderlineid}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    platform() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get("/jiklandigital/platform");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
};